import React, {useEffect, useState} from 'react';
import {makeStyles} from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import LoaderWithBackDrop from "../../../components/LoaderWithBackDrop/LoaderWithBackDrop.comp";
import {
    Paper, Typography, Tabs, Tab, FormControlLabel, Switch, Box
} from '@material-ui/core';

import { getLicensesBillingSummary } from "../../../services/billing.service";
import { BillingStats, InsidersList as PBDQsList } from "./components";
import DQInsiderLedgerTab from './components/DQInsiderLedgerTab.comp';
import DQPBDQReconcileTab from './components/DQReconcileTab.comp.jsx';
import DQTokenLedgerTab from './components/DQTokenLedgerTab.comp';
import BankTransfersTab from './components/BankTransfersTab.comp';
import PaymentSettingsTab from './components/PaymentSettingsTab.comp';


/**
 * Tab order (20 Oct 2026): day-to-day work first, legacy last. The DQ Token rate lives
 * in Payment Settings, saved with the rest of it.
 */
const TABS = {
    BANK_TRANSFERS:   0,
    PAYMENT_SETTINGS: 1,
    DQT_LEDGER:       2,
    CREDIT_LEDGER:    3,
    RECONCILE:        4,
    LEGACY_PAYMENTS:  5,
};

const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(4),
        display: 'flex',
        flexDirection: 'column',
    },
    tabContainer: {
        marginBottom: theme.spacing(3),
        width: '100%'
    }
}));


function LicensesBilling_ORG() {
    const classes = useStyles();

    // Tab state
    const [activeTab, setActiveTab] = useState(0);

    // Dashboard data
    const [dashboardLoading, setDashboardLoading] = useState(false);
    const [dashboardData, setDashboardData] = useState(null);
    
    // DQW visibility toggle
    const [showDQW, setShowDQW] = useState(false);

    useEffect(() => {
        fetchDashboardData();
    }, []);

    const fetchDashboardData = async () => {
        setDashboardLoading(true);
        try {
            const result = await getLicensesBillingSummary();
            if (result && result.data) {
                setDashboardData(result.data);
            }
        } catch (error) {
            console.error('Error fetching billing summary:', error);
        } finally {
            setDashboardLoading(false);
        }
    };

    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
    };

    return (
        <Container component="main" maxWidth='false'>
            <div className={classes.paper}>
                <Typography variant="h5" style={{ fontWeight: 600, margin: 0 }}>
                    PBDQ Payment
                </Typography>
            </div>

            {/* Tab Navigation - Organization Details tab disabled */}
            <Paper className={classes.tabContainer}>
                <Tabs 
                    value={activeTab} 
                    onChange={handleTabChange} 
                    indicatorColor="primary"
                    textColor="primary"
                >
                    <Tab label="Bank Transfers" />
                    <Tab label="Payment Settings" />
                    <Tab label="DQ Token Ledger" />
                    <Tab label="DQ Credit Ledger" />
                    <Tab label="Reconcile" />
                    <Tab label="Legacy Payments" />
                    {/* <Tab label="Organization Details" /> */}
                </Tabs>

            </Paper>

                {activeTab === TABS.LEGACY_PAYMENTS && (
                    <div style={{ width: '100%' }}>
                        <Box display="flex" justifyContent="flex-end" alignItems="center" mb={2} px={1}>
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={showDQW}
                                        onChange={(e) => setShowDQW(e.target.checked)}
                                        color="primary"
                                    />
                                }
                                label={<Typography variant="body2" color="textSecondary">Show DQW Stats</Typography>}
                            />
                        </Box>
                        {dashboardData && (
                            <PBDQsList
                                insiders={dashboardData.insiders}
                                onDataUpdate={fetchDashboardData}
                                showDQW={showDQW}
                            />
                        )}
                        {dashboardData && (
                            <BillingStats
                                summary={dashboardData.billing_summary || dashboardData.summary}
                                showDQW={showDQW}
                            />
                        )}
                        <LoaderWithBackDrop loading={dashboardLoading} />
                    </div>
                )}

                {activeTab === TABS.CREDIT_LEDGER && (
                    <div style={{ width: '100%' }}>
                        <DQInsiderLedgerTab />
                    </div>
                )}

                {activeTab === TABS.RECONCILE && (
                    <div style={{ width: '100%' }}>
                        <DQPBDQReconcileTab />
                    </div>
                )}

                {activeTab === TABS.DQT_LEDGER && (
                    <div style={{ width: '100%' }}>
                        <DQTokenLedgerTab />
                    </div>
                )}

                {activeTab === TABS.BANK_TRANSFERS && (
                    <div style={{ width: '100%' }}>
                        <BankTransfersTab />
                    </div>
                )}

                {activeTab === TABS.PAYMENT_SETTINGS && (
                    <div style={{ width: '100%' }}>
                        <PaymentSettingsTab />
                    </div>
                )}


                {/* Organization Details Tab - DISABLED */}
                {/* Tab content removed as Organization Details tab is disabled */}
        </Container>
    );
}

export default LicensesBilling_ORG;
